import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-bg-secondary border-t border-white/5">
      {/* Main Footer Content */}
      <div className="section-container section-spacing">
        {/* Top Section - Vision Statement */}
        <div className="mb-16">
          <p className="font-accent text-2xl md:text-3xl text-text-secondary mb-6">
            "One Vision. Three Pathways."
          </p>
          <p className="font-body text-text-secondary max-w-3xl leading-relaxed">
            Nzingha Maternal Health transforms systems, the Collective for Cross-Diasporan 
            Reproductive Justice (CCDRJ) shifts narratives, and Somale Restoration Collective 
            heals bodies — together forming a continuum of reproductive justice.
          </p>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-2xl text-text-primary hover:text-brand-accent transition-colors duration-300">
              Somale
            </Link>
            <p className="mt-4 text-sm text-text-secondary leading-relaxed">
              Restoration Collective
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-text-secondary mb-6">
              Navigate
            </h4>
            <nav className="flex flex-col gap-4">
              <Link to="/" data-testid="footer-link-home" className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm">
                Home
              </Link>
              <Link to="/about" data-testid="footer-link-about" className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm">
                About
              </Link>
              <Link to="/offerings" data-testid="footer-link-offerings" className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm">
                Offerings
              </Link>
              <Link to="/book" data-testid="footer-link-book" className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm">
                Book With Me
              </Link>
              <Link to="/ethics" data-testid="footer-link-ethics" className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm">
                Code of Ethics
              </Link>
            </nav>
          </div>

          {/* Connected Initiatives */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-text-secondary mb-6">
              Connected Initiatives
            </h4>
            <nav className="flex flex-col gap-4">
              <a
                href="https://www.nzinghamaternalhealth.org/home"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-nzingha"
                className="text-text-primary hover:text-brand-accent transition-colors duration-300 text-sm flex items-center gap-2"
              >
                Nzingha Maternal Health
                <ArrowUpRight size={14} className="text-brand-accent" />
              </a>
              <span className="text-text-secondary text-sm">
                CCDRJ
              </span>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-text-secondary mb-6">
              Connect
            </h4>
            <div className="flex flex-col gap-4">
              <Link 
                to="/book" 
                data-testid="footer-book-cta"
                className="btn-secondary inline-block text-center"
              >
                Book a Session
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-text-secondary text-xs">
            © {currentYear} Somale Restoration Collective. All rights reserved.
          </p>
          <p className="font-accent text-sm text-text-secondary">
            Healing is Resistance.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
